export enum LoaderButtonType {
  STANDARD = 'standard',
  RAISED = 'raised',
  FLAT = 'flat',
  STROKE = 'stroked',
  ICON = 'icon',
  OUTLINE = 'outline'
}

